import axios from 'axios';
import {get} from '@/utils/local';
import router from "@/router";
import {clearCache} from '@/services/user.service';
import { applyTenantHeader } from '@/utils/tenant';
import { extractTraceId, showTraceError } from '@/utils/trace-error';

let baseUrl = process.env.VUE_APP_BASE_URL;
let maxTime = process.env.MAX_REQ_TIME;

if (process.env.NODE_ENV === 'production') {
    baseUrl = window.globalConfig.rootUrl;
}


// 创建请求服务
const serves = axios.create({
    baseURL: baseUrl,
    timeout: maxTime // 请求超时时间
})

// 设置请求发送之前的拦截器
serves.interceptors.request.use(config => {
    // 统一在http请求的header都加上token
    let token = get('token');
    if (token && token.access_token) {
        config.headers.Authorization = `Bearer ${token.access_token}`
    }
    applyTenantHeader(config);
    return config
}, err => {Promise.reject(err)})

// 设置响应拦截器
serves.interceptors.response.use(response => {
    // 根据响应状态码判断是否请求成功
    //console.log(JSON.stringify(response));
    if (response.status === 200 || response.status === 204) {
        // 即使返回空数据（null、undefined、空数组），也正常返回，不触发错误
        // 空数据是正常的业务场景，不应该触发错误处理
        return Promise.resolve(response.data)
    } else {
        // 如果请求失败，则统一处理错误
        return Promise.reject(response)
    }
}, err => {
    // 取出状态码和消息
    //console.log(JSON.stringify(err));
    let message = '';
    let status = getStatus(err);
    console.log('status', status);
    // 检查是否是真正的401错误（有明确的401响应状态码），而不是网络错误
    // 网络错误不应该直接跳转登录，因为可能是临时网络问题
    const isReal401 = err.response && err.response.status === 401;
    const isNetworkError = err.message && err.message.indexOf("Network Error") != -1;
    
    // 调试日志：记录错误信息，帮助排查问题
    if (isReal401 || isNetworkError) {
        console.warn('请求错误详情:', {
            status,
            isReal401,
            isNetworkError,
            responseStatus: err.response?.status,
            responseData: err.response?.data,
            message: err.message,
            url: err.config?.url
        });
    }
    
    let msg = err.response && err.response.data && err.response.data.error ? (
        err.response.data.error.code ?  err.response.data.error.code : err.response.data.error.details ? err.response.data.error.details :
        err.response.data.error.message ? err.response.data.error.message :
        err.response.data.error_description ? err.response.data.error_description :
        status + '错误') : status + '错误';

    // 提取 TraceId
    let traceId = extractTraceId(err);

    // 判断请求时发生的错误类型，处理不同的错误
    switch (status) {
        case 401:
            // 只有真正的401错误才跳转登录，网络错误不跳转
            if (isReal401) {
                message = '无访问权限';
                clearCache();
                if (router.currentRoute.path !== '/login') { 
                    router.push('/login');
                    
                    console.log('router.currentRoute.path', router.currentRoute.path);
                }
            } else if (isNetworkError) {
                // 网络错误不跳转登录，只提示错误
                message = '网络连接错误，请检查网络后重试';
            } else {
                message = '无访问权限';
            }
            break;
        case 406:
            message = '应用未激活或已过有效期';
            router.push('/app-register');
            break;
        case 403:
            message = msg ? msg :'请求错误';
            break;
        case 415:
            message = '参数格式错误';
            break;
        case 500:
            message = '接口发生错误';
            break;
        case 504:
            message = '请求超时';
            break;
        default:
            message = msg ? msg : `请求错误`;
            break;
    }
    showTraceError(message, traceId, status);
    return Promise.reject(message);
})

function getStatus(err){
    // 网络错误不应该返回401，应该返回特定的网络错误码
    // 但为了保持兼容性，仍然返回401，但在上层逻辑中会区分处理
    if (err.message && err.message.indexOf("Network Error") != -1) {
        return 401; // 标记为401，但会在上层判断是否为真正的401
    }
    if(err.code && err.code == 'ECONNABORTED'){
        return 504;
    }
    let status = err.response && err.response.status ? err.response.status : 403;
    return status;
}

export { serves as default, baseUrl }